/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Totp_Already_EnrolledInputs */

const en_error_totp_already_enrolled = /** @type {(inputs: Error_Totp_Already_EnrolledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An authenticator app is already set up.`)
};

/**
* | output |
* | --- |
* | "An authenticator app is already set up." |
*
* @param {Error_Totp_Already_EnrolledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_totp_already_enrolled = /** @type {((inputs?: Error_Totp_Already_EnrolledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Totp_Already_EnrolledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_totp_already_enrolled(inputs)
});